import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Sun = ({
  className = '~w-3/6 ~h-3/6',
  fill = COLOR.PRIMARY.LIGHT_100,
  fillDarkMode = COLOR.PRIMARY.LIGHT_100
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 37 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M26.4997 18.1667C26.4997 22.769 22.7687 26.5 18.1663 26.5C13.564 26.5 9.83301 22.769 9.83301 18.1667C9.83301 13.5643 13.564 9.83337 18.1663 9.83337C22.7687 9.83337 26.4997 13.5643 26.4997 18.1667Z'
        fill={fillColor}
        stroke={fillColor}
        strokeWidth='3'
      />
      <path
        d='M18.1667 1.5V4V1.5ZM18.1667 32.3333V34.8333V32.3333ZM29.9513 29.9522L28.1835 28.1843L29.9513 29.9522ZM8.14877 8.14877L6.381 6.381L8.14877 8.14877ZM34.8333 18.1667H32.3333H34.8333ZM4 18.1667H1.5H4ZM29.9522 6.38118L28.1843 8.14895L29.9522 6.38118ZM8.14958 28.1845L6.38182 29.9523L8.14958 28.1845Z'
        fill='#D9D9D9'
      />
      <path
        d='M18.1667 1.5V4M18.1667 32.3333V34.8333M29.9513 29.9522L28.1835 28.1843M8.14877 8.14877L6.381 6.381M34.8333 18.1667H32.3333M4 18.1667H1.5M29.9522 6.38118L28.1843 8.14895M8.14958 28.1845L6.38182 29.9523'
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Sun;
